import { Download } from "lucide-react";

import { Button, Modal } from "../../ui/index.ts";
import type { CertificationDocument } from "./use-certification-document.ts";
import styles from "./certification-document-viewer.module.css";

type Props = {
  document: CertificationDocument | null;
  onClose: () => void;
};

export function CertificationDocumentViewer({ document, onClose }: Props) {
  return (
    <Modal
      open={document != null}
      onClose={onClose}
      title={document?.name ?? "Certificate"}
      size="xl"
      closeOnEscape
      bodyClassName={styles.body}
      footer={
        document ? (
          <a className={styles.download} href={document.url} download={document.name}>
            <Download size={16} aria-hidden />
            Download
          </a>
        ) : null
      }
    >
      {document?.contentType === "application/pdf" ? (
        <iframe
          className={styles.preview}
          src={document.url}
          title={document.name}
        />
      ) : document?.contentType.startsWith("image/") ? (
        <img className={styles.image} src={document.url} alt={document.name} />
      ) : document ? (
        <div className={styles.unsupported}>
          <p>Preview is not available for this file type.</p>
          <Button onClick={() => window.open(document.url, "_blank", "noopener,noreferrer")}>
            Open file
          </Button>
        </div>
      ) : null}
    </Modal>
  );
}
